import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "confirm-dialog__msg-block"
};
const _hoisted_2 = {
  class: "confirm-dialog__footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.isVisible,
    title: _ctx.title || _ctx.$t('informationDialog.defaultTitle').toString(),
    width: _ctx.width,
    "close-on-click-modal": _ctx.closeOnOutsideClick,
    onOnDialogClose: _cache[0] || (_cache[0] = $event => _ctx.handleDialogClose())
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_standard_button, {
      label: _ctx.$t('informationDialog.ok').toString(),
      onClick: _ctx.handleDialogClose
    }, null, 8, ["label", "onClick"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("i", {
      class: "icon mdi mdi-information-outline"
    }, null, -1)), _cache[2] || (_cache[2] = _createTextVNode()), _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)])]),
    _: 1
  }, 8, ["visible", "title", "width", "close-on-click-modal"]);
}